/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { toAbsoluteUrl } from "../../../helpers";
import { BadgeStatus } from "../../badges/statusBadge";
import { ColumnOption } from "../../modals/users-by-category/userListByCategoryModal";

export type Props = {
  className: string;
  data?: userListInterface;
  visibleColumns: ColumnOption[];
};

const getCellValue = (user: userInterface, columnId: string) => {
  switch (columnId) {
    case "_id":
      return user._id;
    case "full_name":
      return `${user.first_name} ${user.last_name}`;
    case "birthdate":
      return user.birthdate;
    case "gender":
      return user.gender;
    case "celphone":
      return user.celphone;
    case "cpf":
      return user.cpf;
    case "email":
      return user.email;
    case "instagram":
      return user.instagram;
    default:
      return "";
  }
};

export interface userListInterface {
  category: string;
  users: userInterface[];
}

export interface userInterface {
  _id: number;
  email: string;
  instagram: string;
  celphone: string;
  cpf: string;
  first_name: string;
  last_name: string;
  birthdate: string;
  banned: boolean;
  category: string;
  compliance: boolean;
  overdue: boolean;
  profile_image: string;
  gender: string;
  accessBracelet?: {
    _id: number;
    _id_bracelet_color: number;
    braceletColor: {
      created_at: Date;
      updated_at: Date;
      deleted_at: Date;
      _id: number;
      name: string;
      color: string;
      visitors: boolean;
    };
  };
}

const TablesWidget3: React.FC<Props> = ({
  className,
  data,
  visibleColumns,
}) => {
  const pathUrl = "https://companies-admin.aacceson.com/";

  return (
    <div className={`card ${className} p-0 m-0 w-100`}>
      <div className="card-body p-0 m-0 col-12">
        <div
          className="table-responsive p-0 m-0"
          style={{
            maxHeight: "70vh",
            overflowY: "auto",
            width: "100%",
            minWidth: "100%",
            border: "1px solid #ccc",
          }}
        >
          <table className="table align-middle gs-0 gy-3 w-100">
            <thead>
              <tr>
                {visibleColumns.map((col) => (
                  <th
                    style={{
                      border: "1px solid #ccc",
                      backgroundColor: "#f2f2f2",
                      fontSize: "12px",
                      fontWeight: "bold",
                    }}
                    key={col.id}
                    className={
                      col.id === "full_name"
                        ? "p-2 min-w-150px"
                        : "p-2 min-w-50px"
                    }
                  >
                    {(col.id as string) === "status_badge"
                      ? "Status"
                      : col.label}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data?.users?.length ? (
                data?.users?.map((user, userIndex) => (
                  <tr key={`user_${userIndex}`}>
                    {visibleColumns.map((col) => {
                      const cellValue = getCellValue(user, col.id);
                      if (col.id === "profile_image") {
                        return (
                          <td key={`${userIndex}_${col.id}`}>
                            <div className="symbol symbol-50px me-5">
                              <img
                                style={{
                                  border: `3px solid ${
                                    user?.accessBracelet?.braceletColor?.color
                                      ? user?.accessBracelet?.braceletColor
                                          ?.color
                                      : "not defined"
                                  }`,
                                  width: "3em",
                                  height: "3em",
                                  borderRadius: "3em",
                                }}
                                src={
                                  user.profile_image
                                    ? pathUrl + user.profile_image
                                    : toAbsoluteUrl("/media/avatars/blank.png")
                                }
                                className=""
                                alt=""
                              />
                            </div>
                          </td>
                        );
                      }
                      if (col.id === "full_name") {
                        return (
                          <td
                            key={`${userIndex}_${col.id}`}
                            className="flex-grow"
                          >
                            <p
                              className={`fw-bold ${
                                !user?.compliance || user?.overdue
                                  ? "text-danger text-hover-danger"
                                  : "text-hover-primary"
                              } fs-6 m-0 me-2`}
                            >
                              {cellValue}
                            </p>
                            <small className="text-muted d-block fw-semibold mt-1">
                              {/* {user.email} */}
                            </small>
                          </td>
                        );
                      }
                      if ((col.id as string) === "status_badge") {
                        return (
                          <td
                            key={`${userIndex}_status`}
                            className="text-center text-dark fw-bold fs-6 pe-0"
                          >
                            <BadgeStatus
                              description={
                                user?.overdue && user?.compliance
                                  ? "overdue"
                                  : user?.category
                                  ? user?.category
                                  : user?.accessBracelet?.braceletColor
                                      ?.visitors
                                  ? "visitorsOnline"
                                  : data?.category
                              }
                            />
                          </td>
                        );
                      }
                      return (
                        <td
                          key={`${userIndex}_${col.id}`}
                          className="text-center text-muted fw-semibold"
                        >
                          <small>{cellValue}</small>
                        </td>
                      );
                    })}
                  </tr>
                ))
              ) : (
                <tr className="text-center w-100">
                  <td
                    colSpan={visibleColumns.length}
                    className="w-100 text-start"
                  >
                    Nenhum registro encontrado.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export { TablesWidget3 };
